module.exports = __webpack_public_path__ + "ab69bd2c8cdd0934ccf05766096ff4a4.svg";